module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content_footer"
  }, [_c('ul', {
    staticClass: "nav linkNav"
  }, [_c('li', {
    staticClass: "useful_link"
  }, [_c('a', {
    on: {
      "click": _vm.showAboutTruthso
    }
  }, [_vm._v("关于真相搜索")]), _vm._v("    ")]), _vm._v(" "), _c('li', {
    staticClass: "useful_link",
    on: {
      "click": _vm.userAgree
    }
  }, [_vm._v("用户协议")]), _vm._v(" "), _c('li', {
    staticClass: "useful_link"
  }, [_vm._v("    "), _c('router-link', {
    attrs: {
      "to": "/feedback/"
    }
  }, [_vm._v("问题反馈")])], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "company_info"
  }, [_vm._v("Copyright@2013 - " + _vm._s(_vm.yearTime) + " All rights reserved  -  ")]), _vm._v(" "), _c('li', {
    staticClass: "company_info"
  }, [_vm._v("版权所有：真相网络科技（北京）有限公司")])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "company_info"
  }, [_c('a', {
    staticStyle: {
      "color": "rgb(151, 151, 151)"
    },
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("京ICP备16033891号-1")]), _vm._v("  -  ")]), _vm._v(" "), _c('li', {
    staticClass: "company_info"
  }, [_vm._v("公京检第1792001号  -  ")]), _vm._v(" "), _c('li', {
    staticClass: "company_info"
  }, [_vm._v("公安部安全与警用电子产品质量检测中心  -  ")]), _vm._v(" "), _c('li', {
    staticClass: "company_info"
  }, [_vm._v("国家安全防范报警系统产品质量监督检验中心（北京）")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77437da6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/contentFooter.vue
// module id = 773
// module chunks = 1